import { createFileRoute, redirect } from "@tanstack/react-router";
import { consumeReturnTo } from "../shell-handle/returnTo";

export const Route = createFileRoute("/login/callback")({
  beforeLoad: () => {
    // A captured deep link (returnTo) needs a full navigation so single-spa
    // mounts the target MFE; the "/" fallback then lands on /welcome.
    const target = consumeReturnTo();
    if (target) {
      window.location.assign(target);
      return;
    }
    throw redirect({ to: "/" });
  },
  component: () => null,
});
